/**
 * Created by Jerker Nord on 2021-01-27.
 */
import {AssetQualityLevel, IResourcesGroupConfig, SpriteSheetNameExtension} from "@nolimitcity/slot-game/bin/asset/Asset";
import {BitmapFontAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/BitmapFontAsset";
import {TextureAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/TextureAsset";
import {SpineAsset} from "@nolimitcity/slot-game/bin/asset/assettypes/SpineAsset";
import {Spritesheet} from "pixi.js";
import {Decadence} from "./Decadence";

export class DecadenceGameAssets {
    public static BG_NORMAL:string = "mainBackground";
    public static BG_FREESPIN:string = "freespinBackground";

    public static LOGO_IMAGE:string = "resources/images/introLogo.png";

    public static BITMAP_FONT_OPENSANS_800 = "NumbersOpenSans800";
    public static BITMAP_FONT_SYMBOL:string = "SymbolMain";
    public static BITMAP_FONT_COUNTUP:string = "CountupWhite";
    public static BITMAP_FONT_SYMBOL_SPIN:string = "SymbolMainSpin";

    // Spines
    public static MONSTER_ANIMATION:string = "spine/reel.json";
    public static TV_ANIMATION:string = "spine/reel_screen.json";
    public static BUTTON_ANIMATION:string = "spine/button_reel.json";
    public static LINKED_WINS_ANIMATION:string = "spine/linked_wins.json";
    public static SCATTER_ANIMATION:string = "spine/SC.json";
    public static GRID_ANIMATION:string = "spine/grid_fs.json";
    public static BIG_WIN_ANIMATION:string = "spine/bigwin.json";
    public static FS_INTRO_OUTRO_ANIMATION:string = "spine/fs.json";
    public static WINCAP_ANIMATION:string = "spine/wincap.json";
    public static BG_ANIMATION:string = "spine/bg.json";

    public static createSprite(path:string):PIXI.Sprite {
        return new PIXI.Sprite(Decadence.assetLoader.getTextures(path)[0]);
    }

    public static createSpine(path:string):PIXI.spine.Spine {
        return new PIXI.spine.Spine(Decadence.assetLoader.getSpineAsset(path));
    }

    public static getSymbolTexturePath(symbolName:string, spinning:boolean = false) {
        if(symbolName == "SC" && Decadence.model.isFreeSpins) {
             return "SSC/SSC" + (spinning ? "_spin" : "");
        } else {
            return symbolName + "/" + symbolName + "" + (spinning ? "_spin" : "");
        }
    }

    public static RESOURCES_GROUPS: IResourcesGroupConfig = {
        intro: [],

        main: [
            {
                name: "fonts",
                assets: [
                    new BitmapFontAsset(DecadenceGameAssets.BITMAP_FONT_OPENSANS_800, "fonts/bitmapfonts/NumbersOpenSans800.fnt"),
                    new BitmapFontAsset(DecadenceGameAssets.BITMAP_FONT_SYMBOL, "fonts/bitmapfonts/SymbolMain.fnt"),
                    new BitmapFontAsset(DecadenceGameAssets.BITMAP_FONT_SYMBOL_SPIN, "fonts/bitmapfonts/SymbolMainSpin.fnt"),
                    new BitmapFontAsset(DecadenceGameAssets.BITMAP_FONT_COUNTUP, "fonts/bitmapfonts/CountupWhite.fnt"),
                ]
            },
            {
                name: "backgrounds",
                assets: [
                    new TextureAsset("background0", "sheets/backgroundsJpeg/backgroundsJpeg0.json"),
                    new TextureAsset("background1", "sheets/backgroundsJpeg/backgroundsJpeg1.json"),
                ]
            },
            {
                name: "main",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("main0", "sheets/main/main0.json"),
                ]
            },
            {
                name: "mainJpeg",
                assets: [
                    new TextureAsset("mainJpeg0", "sheets/mainJpeg/mainJpeg0.json"),
                ]
            },
            {
                name: "spine",
                assets: [
                    new SpineAsset(DecadenceGameAssets.TV_ANIMATION, DecadenceGameAssets.TV_ANIMATION),
                    new SpineAsset(DecadenceGameAssets.BUTTON_ANIMATION, DecadenceGameAssets.BUTTON_ANIMATION),
                    new SpineAsset(DecadenceGameAssets.MONSTER_ANIMATION, DecadenceGameAssets.MONSTER_ANIMATION),
                    new SpineAsset(DecadenceGameAssets.LINKED_WINS_ANIMATION, DecadenceGameAssets.LINKED_WINS_ANIMATION),
                    new SpineAsset(DecadenceGameAssets.SCATTER_ANIMATION, DecadenceGameAssets.SCATTER_ANIMATION),
                    new SpineAsset(DecadenceGameAssets.GRID_ANIMATION, DecadenceGameAssets.GRID_ANIMATION),
                    new SpineAsset(DecadenceGameAssets.BIG_WIN_ANIMATION, DecadenceGameAssets.BIG_WIN_ANIMATION),
                    new SpineAsset(DecadenceGameAssets.FS_INTRO_OUTRO_ANIMATION, DecadenceGameAssets.FS_INTRO_OUTRO_ANIMATION),
                    new SpineAsset(DecadenceGameAssets.WINCAP_ANIMATION, DecadenceGameAssets.WINCAP_ANIMATION),
                    new SpineAsset(DecadenceGameAssets.BG_ANIMATION, DecadenceGameAssets.BG_ANIMATION)
                ]
            },
            {
                name: "symbols",
                autoLoad: [AssetQualityLevel.HIGH],
                assets: [
                    new TextureAsset("symbols0", "sheets/symbols/symbols0.json"),
                ],
                animations: {}
            },
        ]
    };
}